import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "priceInput", "qrResult"]

  // Any payment QR specific logic can go here
  // Modal behavior is now handled by the shared modal controller
}
